// Phase 13.3 — Abstract default thumbnails for live events.
// Same event id → same variant (stable hash), but the grid gets visual variety
// because different ids hash to different variants.

const VARIANTS = [
  "/images/event-default-1.webp",
  "/images/event-default-2.webp",
  "/images/event-default-3.webp",
  "/images/event-default-4.webp",
];

// Cheap deterministic string hash (djb2-ish).
function hashStr(s) {
  let h = 0;
  const str = String(s || "");
  for (let i = 0; i < str.length; i++) {
    h = ((h << 5) - h + str.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

const LEGACY_DEFAULT = "/images/live-event-default.png";

export function defaultThumbnailFor(eventId) {
  return VARIANTS[hashStr(eventId) % VARIANTS.length];
}

/** Pick the right thumbnail src for an event:
 *  - real url        → use as-is
 *  - missing/empty   → hashed variant
 *  - legacy default  → hashed variant (so old DB rows don't all look identical)
 */
export function thumbnailFor(event) {
  if (!event) return VARIANTS[0];
  const raw = event.thumbnail_url;
  if (!raw || raw === LEGACY_DEFAULT) return defaultThumbnailFor(event.id);
  return raw;
}

export const DEFAULT_THUMBNAIL_VARIANTS = VARIANTS;
